import * as React from 'react';
import { DropdownMenu, Flex, Typography } from '@ghq-abi/design-system-v2';

import { Avatar } from '~/shared/components';

import { useUserDropdown } from './hooks';

type UserInfo = {
  globalId?: string;
  name?: string;
  zone?: string;
};

type HeaderProps = { user: UserInfo };

export function UserDropdown({ user }: HeaderProps) {
  const { items, profileInfo } = useUserDropdown({ user });

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className="flex items-center gap-2 px-2 py-1 rounded hover:bg-gray-100 border-none bg-transparent cursor-pointer">
          <Avatar globalId={user.globalId} name={user.name} />
          <Flex direction="column" className="hidden lg:flex text-left">
            <Typography variant="body-sm-medium" className="text-gray-800">
              {profileInfo.name}
            </Typography>
            <Typography variant="metadata-xs-regular" className="text-gray-500">
              {profileInfo.zone}
            </Typography>
          </Flex>
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end" className="min-w-[200px]">
        <Flex className="p-3 gap-3 bg-yellow-400 rounded-t">
          <Avatar globalId={user.globalId} name={user.name} />
          <Flex direction="column">
            <Typography variant="body-sm-bold">{profileInfo.name}</Typography>
            <Typography variant="metadata-xs-regular">
              {profileInfo.zone}
            </Typography>
          </Flex>
        </Flex>
        <DropdownMenu.Separator />
        {items.map(item => (
          <DropdownMenu.Item
            key={item.label}
            onSelect={item.onSelect}
            className="cursor-pointer">
            <Flex align="center" className="gap-2">
              {item.icon}
              <Typography variant="body-sm-regular">{item.label}</Typography>
            </Flex>
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
